// utils/perthTime.js
// Standardized Timezone Helpers for Perth, Western Australia (UTC+8 / AWST)

export const PERTH_TIMEZONE = "Australia/Perth";

/**
 * Returns today's date in Perth as YYYY-MM-DD
 */
export function getPerthTodayStr() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: PERTH_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

/**
 * Returns current hour (0-23) in Perth, Australia
 */
export function getPerthHour() {
  const hourStr = new Intl.DateTimeFormat("en-AU", {
    timeZone: PERTH_TIMEZONE,
    hour: "numeric",
    hour12: false,
  }).format(new Date());
  return parseInt(hourStr, 10);
}

/**
 * Returns time-appropriate greeting based on Perth, Australia time
 */
export function getPerthGreeting() {
  const hour = getPerthHour();
  if (hour >= 5 && hour < 12) return "Good Morning";
  if (hour >= 12 && hour < 17) return "Good Afternoon";
  return "Good Evening";
}

/**
 * Formats a date string into standard Australian Perth date (e.g. "11 Jun 2026")
 */
export function formatPerthDate(dateInput, customOptions = {}) {
  if (!dateInput) return "—";
  try {
    const d = typeof dateInput === "string" && dateInput.length === 10
      ? new Date(`${dateInput}T00:00:00+08:00`)
      : new Date(dateInput);

    if (isNaN(d.getTime())) return String(dateInput);

    const defaultOptions = {
      timeZone: PERTH_TIMEZONE,
      day: "2-digit",
      month: "short",
      year: "numeric",
      ...customOptions,
    };

    return new Intl.DateTimeFormat("en-AU", defaultOptions).format(d);
  } catch {
    return String(dateInput);
  }
}

/**
 * Formats date into long Australian format (e.g. "11 June 2026" or "Wednesday, 11 June 2026")
 */
export function formatPerthDateLong(dateInput, includeWeekday = false) {
  return formatPerthDate(dateInput, {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...(includeWeekday ? { weekday: "long" } : {}),
  });
}
